import {AfterViewInit, Component, OnInit} from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';
import {ApiService} from '../../services/api-service/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import * as $ from 'jquery';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-halls',
  templateUrl: './page-open-space.component.html',
  styleUrls: ['../HallsCommon/halls.scss']
})
export class PageOpenSpaceComponent implements OnInit, AfterViewInit {
  public hall = {};
  constructor(
    private UIservice: UiService, 
    private apiService: ApiService, 
    private router: ActivatedRoute,
    private titleService: Title,private meta: Meta
  ) {
    setTimeout(function(){        
      // $('.app-loading').css('display','flex');
      // $('.app-loading').delay(1000).fadeOut('slow'); 
      // $('.app-dummy .left-layer').addClass('active');
      $('main').animate({
        opacity: 1,
      }, 800);
  }, 0);
     
  }


  toggleReserve = (event)  => {
    let target = document.getElementsByClassName('sidebar')[0];
    let target2 = document.getElementsByClassName('hall-info ')[0];
    if (target.classList.contains('closed')) {
      // this.UIservice.closeRightMenu(event);
      this.UIservice.toggleRightMenu(event);
      this.UIservice.toggleRightMenu(event);
      let video = document.getElementsByTagName('video')[0];
      video.muted = !video.muted;
      // document.getElementsByClassName('fullscreenToggler')[0].innerHTML = 'Полноэкранный режим';
      target.classList.remove('closed');
      target2.classList.remove('--closed');
    }
  }


  shallPlayVideo = (): boolean => {
    if (screen.width < 576) {
      return false;
    }
    return true;
  }

  toggleHallInfo = () => {
    let hallInfo = document.getElementsByClassName('hall-info')[0];
    if (screen.width < 576) {
      hallInfo.classList.toggle('--open');
    } else {
      hallInfo.classList.toggle('--closed');
    }
  }


  // toggleFullScreenMode = (event) => {
  //   let target = event.target;
  //   if (target.innerHTML === 'Полноэкранный режим') {
  //     target.innerHTML = 'Свернуть';
  //   } else {
  //     target.innerHTML = 'Полноэкранный режим';
  //   }
  //   this.toggleHallInfo();
  //   this.UIservice.toggleSidebar(event);
  //   this.UIservice.closeRightMenu(event);
  //   let video = document.getElementsByTagName('video')[0];
  //   if (video.muted) {
  //     video.muted = false;
  //   } else {
  //     video.muted = true;
  //   }
  // }

  toggleVideoPlayback = (event) => {
    let video = document.getElementsByTagName('video')[0];
    this.toggleHallInfo();
    this.UIservice.toggleSidebar(event);
    this.UIservice.closeRightMenu(event);
    if (video.muted) {
      video.muted = false;
      video.style.cursor = 'url("../../../assets/full-screen-exit.png"), auto';
    } else {
      video.muted = true;
        video.style.cursor = 'url("../../../assets/full-screen.png"), auto';
    }
    // if (video.paused) {
    //   video.play();
    // } else {
    //   video.pause();
    // }
  }

  ngOnInit() {
    this.UIservice.listenHallInfoToggle().subscribe(() => {
      this.toggleHallInfo();
    });

    console.log(this.router.snapshot.data);
    this.hall = (this.router.snapshot.data.halls['data'].filter(item => item['title'] === 'OPEN SPACE'))[0];
    this.titleService.setTitle(this.hall['meta_title']);
    this.meta.updateTag({name: 'description', content: this.hall['meta_description']});
    this.meta.updateTag({name: 'keywords', content: this.hall['meta_keywords']});

  }

  ngAfterViewInit(): void {
    try {
      let video = document.getElementsByTagName('video')[0];
      video.muted = true;
    } catch (e) {
    }

  }



}
